import { Action, createReducer, on } from '@ngrx/store';
import * as RootActions from './root.actions';
import IRootState, { initializeState } from './root.state';

export const initialState = initializeState();

const reducer = createReducer(
  initialState,
  on(
    RootActions.SetSubdomain,
    (state: IRootState, payload): IRootState => ({
      ...state,
      customSubdomain: payload.subdomain,
    }),
  ),
);

export const RootReducer = (state: IRootState | undefined, action: Action) =>
  reducer(state, action);
